<div class="pagination-container text-center mt-2" *ngIf="totalPages > 1">
    <nav aria-label="Page navigation">
        <ul class="pagination justify-content-center m-0 p-0">
            <li class="page-item" [class.disabled]="currentPage === 0">
                <a class="page-link" (click)="changePage(currentPage - 1)">
                    <img src="./assets/images/icons/arrow-left.png" alt="">
                </a>
            </li>

            <li *ngFor="let page of displayedPages" class="page-item" [class.active]="page === currentPage" (click)="changePage(page)">
                <a class="page-link">{{ page + 1 }}</a>
            </li>

            <li *ngIf="currentPage < totalPages - 3" class="page-item ellipsis">
                <span class="page-link">...</span>
            </li>

            <li *ngIf="totalPages > 3 && currentPage < totalPages - 2" class="page-item" (click)="changePage(totalPages - 2)">
                <a class="page-link">{{ totalPages - 1 }}</a>
            </li>
            <li *ngIf="totalPages > 3 && currentPage < totalPages - 1" class="page-item" (click)="changePage(totalPages - 1)">
                <a class="page-link">{{ totalPages }}</a>
            </li>

            <li class="page-item" [class.disabled]="currentPage >= totalPages - 1">
                <a class="page-link" (click)="changePage(currentPage + 1)">
                    <img src="./assets/images/icons/arrow-right.png" alt="">
                </a>
            </li>
        </ul>
    </nav>
</div>